class DiscountOutput {
  constructor() {
    this.output = "";
    this.error = "";
  }

  daysBetween(first, second) {
    // Copy date parts of the timestamps, discarding the time parts.
    var one = new Date(first.getFullYear(), first.getMonth(), first.getDate());
    var two = new Date(
      second.getFullYear(),
      second.getMonth(),
      second.getDate()
    );

    // Do the math.
    var millisecondsPerDay = 1000 * 60 * 60 * 24;
    var millisBetween = two.getTime() - one.getTime();
    var days = millisBetween / millisecondsPerDay;

    // Round down.
    return Math.floor(days);
  }

  getOutput(date, time, contains = "hour") {
    const splitDate = date.split("-");
    const aimDate = new Date(
      `${splitDate[1]}-${splitDate[0]}-${splitDate[2]} ${timeDiscount}`
    );
    const now = new Date(Date.now());

    const daysCompare = this.daysBetween(now, aimDate);

    //console.log("dateDiscount", dateDiscount);
    // console.log("aimDate", aimDate);
    //console.log("now", now);
    //console.log("aimDate dif", daysCompare);

    let hours = Math.abs(aimDate - now) / 36e5;

    //console.log("aim Hour dif", hours);
    //console.log("--------------");
    //console.log("aimDate getTime", aimDate.getTime());
    //console.log("now getTime", now.getTime());
    //console.log("timeDiscount", timeDiscount);

    if (daysCompare < 0 || aimDate.getTime() < now.getTime()) {
      this.output = `Fırsat Bitti!`;
    } else {
      console.log("output Hala Süre var");
      if (daysCompare > 0 && hours > 24) {
        console.log("output 1 günden(24 saat) uzun sure var");
        if (aimDate.getHours() <= now.getHours())
          this.output = daysCompare > 1 ? `${daysCompare - 1} Gün` : ``;
        else this.output = `${daysCompare} Gün`;
      }

      if (contains === "hour" || contains === "minute") {
        let diffHours = Math.round(hours) % 24;
        this.output = `${this.output} <br> ${diffHours} Saat`;
      }
    }

    return {
      output: this.output,
      error: this.errors,
    };
  }
}
